module.exports = __webpack_public_path__ + "static/fenotipagem-27c51c3a78152e2fb087307dfbb84176.jpg";